export const getRandomNumber = (min, max, excludedNumbers = []) => {
    const random = Math.floor(Math.random() * (max - min)) + min;
    if (excludedNumbers.includes(random)) {
        return getRandomNumber(min, max, excludedNumbers);
    }
    return random;
};
